import React, { useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import { routes } from "../routes";
import Loader from "../components/ui/Loader";
import DynamicMeta from "../components/metaSettings/DynamicMeta";
import { useConfig } from "../context/ConfigContext";
import PageNotFound from "./PageNotFound";
import { urlConfigApi } from "../api/urlConfig";

const AppRoutes = () => {
  const { configReady, error } = useConfig();
  const [redirectChecked, setRedirectChecked] = useState(false);
  const element = useRoutes(routes);

  useEffect(() => {
    if (!configReady) return;

    urlConfigApi
      .findRedirect(window.location.href)
      .then((res) => {
        if (res.redirect && res.newUrl) {
          window.location.replace(res.newUrl);
        } else {
          setRedirectChecked(true);
        }
      })
      .catch(() => setRedirectChecked(true));
  }, [configReady]);

  if (!configReady || !redirectChecked) return <Loader />;
  if (error) return <PageNotFound />;

  return (
    <>
      <DynamicMeta />
      {element}
    </>
  );
};

export default AppRoutes;
